module.exports = __webpack_public_path__ + "static/media/football-headz-cup-2.f7401dd3.jpg";